"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMatchingUserId = void 0;
exports.default = (function () { return window.__PUBLIC_STATE__; });
var isMatchingUserId = function (itemId) {
    return itemId === window.__PUBLIC_STATE__.user.id;
};
exports.isMatchingUserId = isMatchingUserId;
